import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { guest, login, requestPasswordReset } from "../../services/AuthService";
import "./Login.css";

const Login = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const route = searchParams.get("route");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");
  const [forgotError, setForgotError] = useState("");
  const [forgotSubmitting, setForgotSubmitting] = useState(false);
  const navigate = useNavigate();

  const bgStyle = {
    backgroundImage: "url('/geometric-bg.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundColor: "#ffffff",
  };

  const handleGuestSubmit = async () => {
    const parts = route.split("/");
    const uniqid = parts[2];
    const title = parts[3] === "undefined" ? "Proje" : parts[3];
    await guest();
    navigate(`/bugs/${uniqid}/0/${title}`);
    window.location.reload();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await login(email, password, "login");
      route ? navigate(route) : navigate("/dashboard");
      window.location.reload();
    } catch {
      setError("Giriş başarısız. E-posta veya şifre hatalı.");
    }
  };

  const openForgotPassword = () => {
    setForgotOpen((prev) => !prev);
    setForgotMessage("");
    setForgotError("");
    setForgotEmail((prev) => prev || email);
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    const value = String(forgotEmail || "").trim();
    if (!value) {
      setForgotError("Lütfen e-posta adresinizi girin.");
      setForgotMessage("");
      return;
    }

    setForgotSubmitting(true);
    setForgotError("");
    setForgotMessage("");

    try {
      const res = await requestPasswordReset(value);
      setForgotMessage(
        res?.message ||
          "Şifre sıfırlama bağlantısı varsa e-posta adresinize gönderildi."
      );
    } catch (err) {
      const rawMessage = String(err?.message || "").trim().toLowerCase();
      const isUnsupportedRequest =
        rawMessage === "geçersiz istek!" ||
        rawMessage === "gecersiz istek!" ||
        rawMessage.includes("geçersiz istek") ||
        rawMessage.includes("gecersiz istek");

      setForgotError(
        isUnsupportedRequest
          ? "Şifre sıfırlama backend tarafında henüz aktif değil. auth endpoint'ine forgot_password desteği eklenmesi gerekiyor."
          : err?.message ||
            "Şifre sıfırlama isteği şu anda gönderilemedi. Lütfen tekrar deneyin."
      );
    } finally {
      setForgotSubmitting(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="video-section">
        <video src="/login_video.mp4" autoPlay loop muted playsInline />
        <img src="/buglog-white.svg" alt="Buglog" className="corner-logo" />
      </div>

      <div className="form-section" style={bgStyle}>
        <div className="login-container">
          <h2>
            <img src="/buglog.svg" alt="Buglog Logosu" height={50} />
          </h2>

          {route && (
            <>
              <button className="primary-btn" onClick={handleGuestSubmit}>
                Misafir olarak devam et
              </button>
              <div className="invite-alert">
                Giriş yaptıktan sonra davete yönlendirileceksiniz
              </div>
            </>
          )}

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="E-posta"
              />
            </div>
            <div className="input-group">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Şifre"
              />
            </div>
            <div className="login-actions">
              <button
                type="button"
                className="forgot-link"
                onClick={openForgotPassword}
              >
                {forgotOpen ? "Şifre sıfırlamayı kapat" : "Şifremi unuttum"}
              </button>
            </div>
            {error && <p className="error-message">{error}</p>}
            <button type="submit" className="primary-btn">
              <img src="/white_icon.svg" alt="" height={16} />
              Giriş Yap
            </button>
          </form>

          {forgotOpen && (
            <form className="forgot-panel" onSubmit={handleForgotPassword}>
              <div className="forgot-panel-head">
                <strong>Şifre Sıfırlama</strong>
                <span>Kayıtlı e-posta adresinize bağlantı gönderelim.</span>
              </div>
              <div className="input-group forgot-input-group">
                <input
                  type="email"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  placeholder="E-posta adresiniz"
                  autoComplete="email"
                  inputMode="email"
                />
              </div>
              {forgotError ? (
                <p className="forgot-feedback error">{forgotError}</p>
              ) : null}
              {forgotMessage ? (
                <p className="forgot-feedback success">{forgotMessage}</p>
              ) : null}
              <button
                type="submit"
                className="secondary-btn"
                disabled={forgotSubmitting}
              >
                {forgotSubmitting ? "Gönderiliyor..." : "Sıfırlama Linki Gönder"}
              </button>
            </form>
          )}

          <p className="register-prompt">
            Hesabınız yok mu?{" "}
            <button
              onClick={() => navigate("/register")}
              className="register-link"
            >
              Kayıt Ol
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
